/** Display labels for non-IT users. Keep stored enums unchanged. */

export function roleLabel(role) {
  switch (role) {
    case 'maker':
      return 'Writer';
    case 'checker':
      return 'Reviewer';
    case 'admin':
      return 'Admin';
    case 'reader':
      return 'Reader';
    default:
      return role || '';
  }
}

export function articleStatusLabel(status) {
  switch (status) {
    case 'draft':
      return 'Draft';
    case 'pending':
      return 'Waiting for review';
    case 'approved':
      return 'Ready to publish';
    case 'rejected':
      return 'Needs changes';
    case 'published':
      return 'Live';
    default:
      return status || '';
  }
}

export function categoryLabel(category) {
  if (!category || category === 'all') return 'All';
  return category.charAt(0).toUpperCase() + category.slice(1);
}

export function displayTitle(title) {
  const cleaned = String(title || '')
    .replace(/,\s*$/, '')
    .trim();
  return cleaned || 'Untitled';
}

export function activityLabel(type) {
  switch (type) {
    case 'open':
      return 'Opened';
    case 'click':
      return 'Tapped';
    case 'share':
      return 'Shared';
    case 'react':
      return 'Reacted';
    case 'view':
      return 'Viewed';
    default:
      return type || 'Activity';
  }
}

export function alertKindLabel(kind) {
  switch (kind) {
    case 'banner':
      return 'Photo';
    case 'audio':
      return 'Audio';
    case 'video':
      return 'Video';
    case 'actionable':
      return 'Action needed';
    case 'standard':
      return 'Message';
    default:
      return kind || 'Message';
  }
}
